import { __decorate } from "tslib";
import '../../../../atom/input/element';
import '../../../../atom/label/element';
import '../../form-msg/element';
import { DefaultText } from '../../../../../lib/validate/defaultText';
import { CheckErrorMsg } from '../../../../../lib/validate/checkErrorMsg';
import { css, LitElement, html } from 'lit';
import { property, query, state } from 'lit/decorators.js';
export var dateType;
(function (dateType) {
    dateType["date"] = "date";
    dateType["dateTimeLocal"] = "dateTimeLocal";
    dateType["month"] = "month";
    dateType["time"] = "time";
    dateType["week"] = "week";
})(dateType || (dateType = {}));
export class FormInputText extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.value = '';
        this.disabled = false;
        this.isDate = false;
        this.required = false;
        this.requiredInfoText = '* This field is required';
        this.repeat = false;
        this.iconName = 'ep';
        this.__loaded = false;
        this.keydown = (e) => {
            e.stopImmediatePropagation();
            e.stopPropagation();
            return;
        };
        this.notSameValueEvent = (e) => {
            const detail = e.detail;
            if (detail.name !== this.name && this.notSameValueName === detail.name) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.notSameValue = detail.value;
                new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
            }
        };
        this.sameValueEvent = (e) => {
            const detail = e.detail;
            if (((this.name.includes(detail.name) && this.name.includes('Repeat')) || this.name === detail.name.replace('Repeat', '')) &&
                this.name !== detail.name) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.repeatValue = detail.value;
                new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
            }
        };
    }
    render() {
        return html `
            <div class="wrp">
                <ep-input
                    ?isDate="${this.isDate}"
                    name="${this.name}"
                    id="${this.name} Input"
                    type="${this.type}"
                    @keyup="${this.keyup}"
                    @change="${this.change}"
                    .value="${this.value}"
                    @keydown="${this.keydown}"
                ></ep-input>
                <ep-icon name="${this.iconName}" @click="${this.clickIcon}"></ep-icon>
                <ep-label for="${this.name}" @click="${this.click}">${this.label}</ep-label>
            </div>
            <ep-form-msg infoText=${this.infoText || ''}></ep-form-msg>
        `;
    }
    firstUpdated() {
        this.__loaded = true;
        this.__alreadyRun = false;
        this.validator = new DefaultText(this);
        if (this.hasAttribute('repeat') || (this.name && this.name.includes('Repeat'))) {
            document.addEventListener('inputSameValue', this.sameValueEvent);
        }
        if (this.notSameValueName) {
            document.addEventListener('inputNotSameValue', this.notSameValueEvent);
        }
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.value !== undefined && this.value !== '') {
            this._inputItem.value = this.value;
        }
        if (this.placeholder !== undefined) {
            this._inputItem.setAttribute('placeholder', this.placeholder);
            this._inputItem.classList.add('label-top');
        }
        if (this.hasAttribute('repeat') && !this.__alreadyRun && !this.name.includes('Repeat')) {
            this.watchRepeat();
        }
        if (this.hasAttribute('required')) {
            this.watchRequired();
        }
        if (this.infoText !== undefined && !this.hasAttribute('required')) {
            this._formMsg.infoText = this.infoText;
        }
        if (this._inputItem.hasAttribute('disabled')) {
            this._inputItem.removeAttribute('disabled');
        }
        if (this.hasAttribute('disabled')) {
            this._inputItem.setAttribute('disabled', '');
        }
        if (this.hasAttribute('not-valid')) {
            this._inputItem.setAttribute('not-valid', '');
        }
        if (!this.hasAttribute('not-valid')) {
            this._inputItem.removeAttribute('not-valid');
        }
    }
    disconnectedCallback() {
        document.removeEventListener('inputSameValue', this.sameValueEvent);
        document.removeEventListener('inputNotSameValue', this.notSameValueEvent);
    }
    // todo: check if really needed | date need it (maybe refactor)
    watchValue() {
        var _a;
        const value = this.value;
        if (this.value === undefined || this.value === null || this.value === '') {
            this.removeAttribute('value');
            new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
            return;
        }
        this.setAttribute('value', this.value);
        if (!this.__loaded && value !== 'null' && value.trim() !== '' && value !== 'undefined') {
            (_a = this._inputItem) === null || _a === void 0 ? void 0 : _a.setAttribute('value', value);
        }
        if (!this.__loaded) {
            return;
        }
        new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
        if (value !== 'null' && value.trim() !== '' && value !== 'undefined') {
            this._inputItem.setAttribute('value', value);
        }
    }
    /*
    watchValid() {
        if (this.notValid !== null) {
            this._inputItem.setAttribute('not-valid', '')
            return
        }

        this._inputItem.removeAttribute('not-valid')
    }*/
    click(e) {
        e === null || e === void 0 ? void 0 : e.stopImmediatePropagation();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        this._inputItem.focus();
    }
    change(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const evt = e;
        if (this.notSameValueName) {
            const event = new CustomEvent('inputNotSameValue', {
                detail: {
                    name: this.name,
                    value: evt.detail
                }
            });
            document.dispatchEvent(event);
        }
        if (this.repeat || this.hasAttribute('repeat') || this.name.includes('Repeat')) {
            const event = new CustomEvent('inputSameValue', {
                detail: {
                    name: this.name,
                    value: evt.detail
                }
            });
            document.dispatchEvent(event);
        }
        this.value = evt.detail;
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: this.value
        }));
        new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
    }
    keyup(e) {
        const evt = e;
        if (evt.key === 'Enter') {
            this.dispatchEvent(new CustomEvent('submitFormOnEnter', {
                composed: true,
                bubbles: true
            }));
        }
    }
    clickIcon(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
    }
    watchRepeat() {
        this.setAttribute('required', '');
        const repeatElement = this.cloneNode(false);
        repeatElement.setAttribute('name', `${this.name}Repeat`);
        repeatElement.infoText = '';
        repeatElement.removeAttribute('repeat');
        repeatElement.setAttribute('value', '');
        repeatElement.setAttribute('label', `${this.repeatLabel}`);
        repeatElement.repeatValue = this.value;
        if (this.requiredErrorMsg)
            repeatElement.requiredErrorMsg = this.requiredErrorMsg;
        if (this.repeatErrorMsg)
            repeatElement.repeatErrorMsg = this.repeatErrorMsg;
        if (this.repeatInfoText !== undefined) {
            repeatElement.setAttribute('infoText', this.repeatInfoText);
        }
        this.after(repeatElement);
        if (repeatElement.hasAttribute('showStrength')) {
            repeatElement.removeAttribute('showStrength');
            repeatElement.showStrength = false;
        }
        this.__alreadyRun = true;
    }
    watchRequired() {
        var _a;
        this._inputItem.setAttribute('required', '');
        if (!((_a = this.infoText) === null || _a === void 0 ? void 0 : _a.includes(`${this.requiredInfoText}`)) && this.infoText !== undefined) {
            this.infoText = `${this.requiredInfoText} <br/> ${this.infoText}`;
            this._formMsg.infoText = this.infoText;
        }
        if (this.infoText === undefined) {
            this.infoText = `${this.requiredInfoText}`;
            this._formMsg.infoText = this.infoText;
        }
    }
    reset() {
        this.value = '';
        // todo: check if really needed
        this._inputItem.value = '';
        this._inputItem._input.value = '';
        this._inputItem.removeAttribute('value');
        this._inputItem._input.removeAttribute('value');
        this._inputItem.classList.remove('label-top');
        this._formMsg.errorP.style.display = 'none';
        this._inputItem.removeAttribute('not-valid');
    }
}
FormInputText.styles = css `
        :host {
            position: relative;
            display: block;
            --ep-input-padding: var(--ep-form-input-padding);
            --ep-input-text-font-size: var(--ep-form-input-text-font-size);
        }

        ep-label {
            display: block;
            position: absolute;
            pointer-events: none;
            left: 5px;
            top: 50%;
            --ep-text-font-size: var(--ep-form-label-text-font-size, 14px);
            transform: translateY(-50%);
            transition: 0.1s ease all;
            -moz-transition: 0.1s ease all;
            -webkit-transition: 0.1s ease all;
            background-color: var(--ep-color-white);
            padding: 0 10px;
        }

        :host([disabled]) ep-label {
            background-color: transparent;
        }
        :host([disabled]) ep-input.label-top ~ ep-label {
            background-color: var(--ep-color-white);
        }

        :host([required]) ep-label:after {
            content: '*';
            font-size: 12px;
            vertical-align: top;
            color: var(--ep-label-text-color, var(--ep-text-color));
        }

        :host([noafter]) ep-label:after {
            display: none;
        }

        .wrp {
            position: relative;
        }

        ep-input.focus ~ ep-label {
            --ep-label-text-color: var(--ep-color-primary);
        }

        ep-input[not-valid] ~ ep-label {
            --ep-label-text-color: var(--ep-color-danger);
        }

        ep-input.label-top ~ ep-label,
        ep-input.focus ~ ep-label,
        :host([focus]) ep-input ~ ep-label {
            top: 0px;
            --ep-text-font-size: 14px;
        }

        ep-icon[name='ep'] {
            display: none;
        }

        ep-icon {
            position: absolute;
            --ep-icon-height: var(--ep-input-icon-height, 25px);
            --ep-icon-color: var(--ep-input-icon-color, var(--ep-color-gray-7));
            top: var(--ep-input-icon-top, 5px);
            right: var(--ep-input-icon-right, 5px);
            cursor: pointer;
        }
    `;
__decorate([
    property()
], FormInputText.prototype, "placeholder", void 0);
__decorate([
    property()
], FormInputText.prototype, "name", void 0);
__decorate([
    property()
], FormInputText.prototype, "label", void 0);
__decorate([
    property()
], FormInputText.prototype, "value", void 0);
__decorate([
    property()
], FormInputText.prototype, "infoText", void 0);
__decorate([
    property({ type: Boolean })
], FormInputText.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], FormInputText.prototype, "isDate", void 0);
__decorate([
    property({ type: Boolean })
], FormInputText.prototype, "required", void 0);
__decorate([
    property()
], FormInputText.prototype, "requiredErrorMsg", void 0);
__decorate([
    property()
], FormInputText.prototype, "requiredInfoText", void 0);
__decorate([
    property()
], FormInputText.prototype, "min", void 0);
__decorate([
    property()
], FormInputText.prototype, "max", void 0);
__decorate([
    property({ type: Number })
], FormInputText.prototype, "minLength", void 0);
__decorate([
    property()
], FormInputText.prototype, "minLengthErrorMsg", void 0);
__decorate([
    property({ type: Number })
], FormInputText.prototype, "maxLength", void 0);
__decorate([
    property()
], FormInputText.prototype, "maxLengthErrorMsg", void 0);
__decorate([
    property({ type: Boolean })
], FormInputText.prototype, "notValid", void 0);
__decorate([
    property({ type: Boolean })
], FormInputText.prototype, "repeat", void 0);
__decorate([
    property()
], FormInputText.prototype, "repeatLabel", void 0);
__decorate([
    property()
], FormInputText.prototype, "repeatInfoText", void 0);
__decorate([
    property()
], FormInputText.prototype, "repeatErrorMsg", void 0);
__decorate([
    property()
], FormInputText.prototype, "iconName", void 0);
__decorate([
    property()
], FormInputText.prototype, "notSameValue", void 0);
__decorate([
    property()
], FormInputText.prototype, "notSameValueErrorMsg", void 0);
__decorate([
    property()
], FormInputText.prototype, "notSameValueName", void 0);
__decorate([
    property()
], FormInputText.prototype, "regExp", void 0);
__decorate([
    property()
], FormInputText.prototype, "regExpErrorMsg", void 0);
__decorate([
    state()
], FormInputText.prototype, "repeatValue", void 0);
__decorate([
    query('ep-label')
], FormInputText.prototype, "_labelItem", void 0);
__decorate([
    query('ep-input')
], FormInputText.prototype, "_inputItem", void 0);
__decorate([
    query('ep-form-msg')
], FormInputText.prototype, "_formMsg", void 0);
__decorate([
    query('ep-icon')
], FormInputText.prototype, "_iconElement", void 0);
if (!customElements.get('ep-form-input-text')) {
    customElements.define('ep-form-input-text', FormInputText);
}
//# sourceMappingURL=element.js.map